import { SVGProps, Ref, forwardRef } from 'react';

export const PriceTagOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.315 2.68c1.505.132 2.018 1.226 2.018 2.32 0 1.166-.583 2.333-2.333 2.333S8.666 6.166 8.666 5l.007-.219c.07-1.089.687-2.115 2.327-2.115zM11 4.066c-.538 0-.696.164-.748.226-.09.107-.186.333-.186.708s.097.6.186.708c.052.062.21.225.748.225.537 0 .695-.162.747-.225.09-.107.186-.333.186-.708s-.097-.6-.186-.708c-.052-.063-.21-.226-.747-.226"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m16 7.999-1.1 3.612-.262.852c-.578 1.859-.969 2.842-1.826 3.296l-.187.087c-.823.332-1.836.094-3.565-.435l-.454-.14c-.617.486-1.135.73-1.712.731-1.105 0-1.994-.89-3.772-2.667l-.457-.457C.943 11.156.055 10.268.001 9.21l-.003-.104c0-.966.681-1.767 2.042-3.143l.625-.628L8 0h8zM3.034 6.946c-.688.696-1.112 1.16-1.373 1.537-.237.344-.263.512-.263.623l.001.037c.007.12.056.333.413.79.378.486.956 1.07 1.842 1.956l.457.457c.917.916 1.508 1.502 1.998 1.876.458.349.661.38.785.38.111 0 .28-.026.623-.263.376-.26.838-.685 1.532-1.371l.628-.625L14.6 7.42V1.4H8.58zm7.631 6.389-.628.625-.223.216c.61.182 1.078.307 1.468.374.571.097.766.028.875-.03.11-.057.276-.18.517-.705.258-.564.505-1.365.886-2.612l.334-1.098z"
                fill="currentColor"
            />
        </g>
    </svg>
));
PriceTagOutlinedSize16Glyph.displayName = 'PriceTagOutlinedSize16Glyph';
